var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      ref: "newPopover",
      attrs: {
        title: "详情",
        visible: _vm.dialogShow,
        modal: false,
        "modal-append-to-body": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogShow = $event
        },
        close: function($event) {
          return _vm.clearData()
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "popover",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "80px" }
        },
        _vm._l(_vm.form.params, function(item, index) {
          return _c(
            "div",
            {
              key: index,
              staticStyle: {
                width: "100%",
                display: "flex",
                "justify-content": "space-between",
                "flex-wrap": "wrap"
              }
            },
            [
              _c("div", { staticClass: "langTitle" }, [
                _vm._v(" " + _vm._s(item.languageName) + " ")
              ]),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "商品简介",
                    prop: "params." + index + ".content",
                    rules: _vm.rules.content
                  }
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入商品简介" },
                    model: {
                      value: item.content,
                      callback: function($$v) {
                        _vm.$set(item, "content", $$v)
                      },
                      expression: "item.content"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "商品名称",
                    prop: "params." + index + ".product_name",
                    rules: _vm.rules.product_name
                  }
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入" },
                    model: {
                      value: item.product_name,
                      callback: function($$v) {
                        _vm.$set(item, "product_name", $$v)
                      },
                      expression: "item.product_name"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    label: "宣传图",
                    prop: "params." + index + ".icon",
                    rules: _vm.rules.icon
                  }
                },
                [
                  _c("uploadImage", {
                    attrs: { disabled: "", value: item.picfileList },
                    on: {
                      input: function($event) {
                        return _vm.imgChange($event, item, index)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }